import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import './label.scss'

const classes = generateClassNames('label', ['asterisk'])

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  disabled?: boolean
  required?: boolean
}

const Label = forwardRef(function Label(
  props: LabelProps,
  ref: React.ForwardedRef<HTMLLabelElement>
) {
  const { children, className, disabled, required, ...other } = props

  return (
    <label
      ref={ref}
      className={clsx(
        classes.root,
        disabled && `${classes.root}--disabled`,
        className
      )}
      {...other}
    >
      {children}
      {required && (
        <span aria-hidden='true' className={classes.asterisk}>
          {'*'}
        </span>
      )}
    </label>
  )
})

export default Label
